// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"51550a48","431":"9f87ee99"}[chunkId] + ".chunk.css";
};